import { render, staticRenderFns } from "./CartAddressItem.vue?vue&type=template&id=24476cc4&scoped=true"
import script from "./CartAddressItem.vue?vue&type=script&lang=js"
export * from "./CartAddressItem.vue?vue&type=script&lang=js"
import style0 from "./CartAddressItem.vue?vue&type=style&index=0&id=24476cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24476cc4",
  null
  
)

export default component.exports